export const esTranslation = {
  "dyn": {
    "dynamic": "Paquetes deportivos y musicales",
    "predefined": "Paquete recomendado",
    "self": "Diseña tu experiencia",
    "event_type": "Tipo de evento",
    "event_music": "Destino / Artista / Festival",
    "event_sport": "Objetivo / Equipo / Liga",
    "sport_type": "Tipo de deporte",
    "people": "Personas",
    "sport": "Deporte",
    "music": "Música",
    "package_details": "Detalles del paquete",
    "ticket": "Entrada",
    "from_here": "Desde aquí",
    "your_choice": "Tu elección",
    "extra_money": "Suplemento por pasajero",
    "filter_results": "Filtrar resultados de búsqueda",
    "not_found": "Atracción no encontrada",
    "fl_htl_ticket": "Vuelo + hotel + entrada",
    "fl_pl_htl": "Vuelo + hotel",
    "image_for_illustration": "La imagen del estadio/auditorio es solo para ilustración",
    "supplement_card": "Suplemento de la tarjeta",
    "card_category": "Categoría de la tarjeta",
    "to_order": "Para ordenar",
    "outbound_flight": "Salida",
    "return_flight": "Regreso",
    "card": "Detalles del evento",
    "tickets_amount": "Cantidad de entradas",
    "ticket_date": "Fecha del evento",
    "terms": "Términos de uso de este sitio",
    "general_conditions": "Condiciones generales y tarifas de cancelación",
    "its_your_read": "Es su responsabilidad leer",
    "general_conditions_cancellation": "Condiciones generales y cancelaciones",
    "all_conditions_time": "y todos los términos y condiciones relativos a su tiempo",
    "the_event_ticket": "El billete del evento",
    "full_cancellation_fees": "está sujeto a tarifas completas de cancelación",
    "no_cancellation_fees": "Sin tarifas de cancelación hasta",
    "handling_fees": "Tarifas de gestión",
    "cancellation_50": "Por gestionar la cancelación de una reserva, la compañía de viajes cobrará $50 por pasajero además de las tarifas de cancelación de los distintos proveedores",
    "from_the_moment": "desde el momento en que se realiza el pedido",
    "add_forward_transfer": "Agregar traslado desde el aeropuerto al hotel",
    "add_two_way_transfer": "Agregar traslado desde el aeropuerto al hotel y de regreso",
    "arrival_transfer": "Traslado de llegada",
    "return_transfer": "Traslado de regreso",
    "no_avail": "Lo sentimos, no encontramos un paquete disponible",
    "search_again": "Buscar de nuevo",
    "fl_htl": "Vuelo + hotel",
    "select_fare": "Seleccione tarifa {{from}} a {{to}}",
    "change_fare": "Cambiar tarifa",
    "per_passenger": "Por pasajero",
    "hotel_not_found": "Hotel no encontrado",
    "flight_not_found": "Vuelo no encontrado",
    "error": "Algo salió mal",
    "attraction_not_found": "Atracción no encontrada",
    "tlv": "TLV - Aeropuerto Internacional Ben Gurion, Tel Aviv Yafo",
    "event_date_warning": "La fecha del evento debe estar dentro de las fechas seleccionadas",
    "choose_room": "Elegir habitación",
    "event": "Evento",
    "packages": "Paquetes dinámicos",
    "there_is_no_any_room_please_choose_another_hotel": "No hay ninguna habitación disponible, elija otro hotel"
  },
  "REG": "Standard",
  "tlv": "TLV - Tel Aviv",
  "flight": {
    "flight": "Vuelo",
    "s": "Vuelos",
    "from": "Salida desde",
    "to": "Destino",
    "departing": "Salida",
    "returning": "Regreso",
    "date": "Fecha",
    "choose_persons": "Viajeros",
    "dates": "Fechas",
    "details": "Detalles del vuelo",
    "class": "Clase",
    "economy": "Turista",
    "business": "Negocios",
    "economy_premium": "Turista Premium",
    "baggage": "Equipaje",
    "round_trip": "Ida y vuelta",
    "one_way": "Solo ida",
    "multiple_destinations": "Múltiples ciudades",
    "found_from": "vuelos encontrados desde ",
    "details_segment": "Detalles del vuelo",
    "forward": "Ida",
    "total_price": "Precio total",
    "avarage_per_passenger": "Promedio por pasajero",
    "seats_available": "asientos disponibles",
    "no_suitcases_allowed": "No se permiten maletas",
    "airline_allow_one": "La aerolínea permite una maleta",
    "airline_allow_multiple": "La aerolínea permite {{count}} maletas",
    "airline_allow_max": "La aerolínea permite maleta de hasta {{weight}}",
    "outbound": "Salida",
    "inbound": "Regreso",
    "direct_only": "Solo directo",
    "order_details": "Detalles de la reserva",
    "order_summary": "Resumen de la reserva",
    "departure_date": "Fecha de salida",
    "return_date": "Fecha de regreso",
    "usa_warning": "Tenga en cuenta que en caso de cruzar o hacer escala en Estados Unidos se requiere visa incluso si es un vuelo de conexión; es responsabilidad del cliente gestionarla.",
    "total_average_passenger": "Promedio total por pasajero",
    "total_per_package": "Total por paquete",
    "departure": "Salida",
    "return": "Regreso",
    "departure_time": "Hora de salida",
    "departure_airport": "Aeropuerto de salida",
    "arrival_time": "Hora de llegada",
    "arrival_airport": "Aeropuerto de llegada",
    "aircraft": "Tipo de Avión",
    "seats_available_up": "Asientos disponibles",
    "show_details": "Mostrar detalles",
    "frequent_flyer_airline": "Aerolínea de viajero frecuente",
    "frequent_flyer_number": "Número de viajero frecuente",
    "updgrade": "Mejora tu vuelo elegido",
    "info_and_conditions": "Información y condiciones generales",
    "it_is_your": "Es su responsabilidad leer ",
    "all_rules": "todas las reglas y restricciones",
    "according_this": " según este vuelo",
    "booking_summary": "Resumen de la reserva",
    "airport": "Aeropuerto",
    "service_time": "Hora de servicio",
    "pickup_time": "Hora de recogida",
    "additional_info": "Información adicional",
    "number": "Número de vuelo",
    "to_airport": "Al aeropuerto",
    "handbag_included": "Bolso de mano incluido",
    "handbag_excluded": "Sin bolso de mano",
    "trolley_excluded": "Sin trolley",
    "trolley_included": "Trolley incluido",
    "bag_included": "Equipaje incluido",
    "bag_excluded": "Sin equipaje",
    "airline_desc_and": "Descripción de la aerolínea y",
    "link": "enlace",
    "airline": "Aerolínea",
    "dep_time": "Hora de salida",
    "arr_time": "Hora de llegada",
    "dep_airport": "Aeropuerto de salida",
    "arr_airport": "Aeropuerto de llegada",
    "elapsed_time": "Duración",
    "all_baggage_information_on_the_airline_website": "Toda la información sobre equipaje en el sitio web de la aerolínea",
    "operated_by": "Operado por",
    "base": "Base",
    "tax": "Impuesto",
    "SFM": "SFM",
    "book_2": "Reservar 2 trayectos",
    "professional_mode": "Modo profesional",
    "client_mode": "Modo cliente",
    "incl_handbag": "Incl. bolso",
    "incl_suitcase": "Incl. maleta",
    "incl_bag": "Incl. equipaje",
    "incl_baggage": "Incl. equipaje {{price}}",
    "incl_suitcase_kg": "Incl. maleta {{kg}} kg",
    "no_baggage": "Sin equipaje",
    "incl_handbag_kg": "Incl. bolso {{kg}} kg",
    "without_handbag": "Sin bolso",
    "add_another_flight": "Agregar vuelo"
  },
  "hotel_info": "Precio e informacion del hotel",
  "hotel": {
    "remove_preffered": "Quitar como hotel preferido",
    "hotel": "Hotel",
    "s": "Hoteles",
    "found_from": "Hoteles encontrados",
    "full_cancellation_fee": "Cancelación completa",
    "free_cancel_before": "Cancelación gratuita antes de",
    "show_rooms": "Mostrar habitaciones",
    "show_all_rooms": "Mostrar todas las habitaciones",
    "boarding": "La Base del alojamiento",
    "refund_limit": "Cancelación gratuita",
    "refund_price": "Precio de reembolso",
    "nights": "noches",
    "rooms": "Habitaciones",
    "room": "Habitación",
    "room_details": "Detalles de la habitación",
    "nights_up": "Noches",
    "select_room": "Seleccione su habitación",
    "filter": "Filtrar...",
    "location": "Ubicación del hotel",
    "book": "Reserva",
    "overview": "Información general",
    "facilities": "Instalaciones del hotel",
    "details": "Detalles del hotel",
    "dates": "Fechas",
    "name": "Nombre del hotel",
    "non_refundable": "No reembolsable",
    "rooms_prices": "Habitaciones y precios ({{count}})",
    "desc": "Descripción del hotel",
    "fac": "Instalaciones",
    "gallery": "Galería",
    "choose_rooms": "Elige habitación",
    "single_room": "1 Habitación - {{price}}",
    "multi_rooms": "{{count}} Habitaciones - {{price}}",
    "rooms_price": "Habitaciones y precios",
    "paxes": "Composición de la habitación",
    "room_type": "Tipo de habitación",
    "room_types": "Sala AI",
    "more_room_types": "{{count}} más tipos de habitación",
    "description": "Descripción",
    "address": "Dirección",
    "loc": "Ubicación",
    "hotel_facilities": "Instalaciones del hotel",
    "room_facilities": "Instalaciones de la habitación",
    "please_note": "Atención",
    "you_can_choose": "Puede elegir hasta {{count}} paxes",
    "we_suggestion": "Hemos encontrado más sugerencias para usted",
    "max_rooms": "Por favor, elija no más de {{count}} habitaciones",
    "max_paxes": "Por favor, elija no más de {{count}} paxes",
    "specific_out": "La habitación específica se agotó, aquí hay alternativas",
    "select_rooms": "Seleccionar habitaciones",
    "info": "Información del hotel",
    "checking_room_availability": "Comprobando disponibilidad de habitaciones...",
    "one_hotel_search_failed": "La habitación elegida no está disponible, por favor elija otra habitación",
    "price_per_night": "Precio por noche",
    "grp": "Grupo",
    "brd": "Embarque",
    "bdr": "Habitación",
    "typ": "Tipo",
    "vew": "Paisaje",
    "bed": "Cama",
    "ada": "Accesibilidad",
    "pax": "Composición de la habitación",
    "cat": "Categoría",
    "blc": "Balcón",
    "cap": "Capacidad",
    "sgl": "Uso individual",
    "shr": "Compartido",
    "filter_room_type": "Filtrar por habitación AI",
    "open_fitler": "Abre",
    "show_room_types": "Mostrar los tipos de habitaciones",
    "hide_room_types": "Ocultar los tipos de habitación",
    "pay_credit_card": "Paga con tarjeta de crédito",
    "paid_successfully": "Pagado correctamente",
    "group_rooms": "Agrupar habitaciones",
    "ungroup_rooms": "Desagrupar habitaciones",
    "make_the_rooms_white": "Hacer las habitaciones blancas",
    "make_the_rooms_colored": "Hacer las habitaciones de color",
    "supplier": "Proveedor",
    "order_summary": "Resumen del pedido",
    "with_meal": "Con comida",
    "meal": "Comida",
    "display_settings": "Opciones de visualización",
    "room_display": "Mostrar habitación",
    "clear_room_name": "Borrar nombre de habitación",
    "filter_rooms": "Filtrar habitaciones similares",
    "our_lowest_prices": "Nuestros precios más bajos",
    "show_cube_design": "Mostrar diseño de cubo",
    "show_rooms_in_tab": "Mostrar habitaciones en ficha",
    "show_cube_design_by_eat": "Mostrar diseño de cubo por abordaje",
    "is_short_mode": "Modo fila",
    "company_id": "Empresa #:",
    "rem_condition": "Condición de observaciones",
    "remarks": "Observaciones",
    "backoffice_trip": "BackOffice/Trip#: (0 = nuevo viaje)",
    "cancellation_policy": "Política de cancelación",
    "sales_price": "Precio de venta",
    "percent": "Porcentaje",
    "amount": "Importe",
    "professional": "Profesional",
    "client": "Cliente",
    "professional_single": "Agente - Fila única",
    "professional_single_multi": "Agente - Fila única (Multi Precio)",
    "professional_single_2": "Agente - Fila única por habitación",
    "loca": "Ubicación",
    "professional_v3": "Agente - Base/Categoría",
    "business_new": "Negocio - Base/Categoría",
    "price_new": "Negocio - Categoría/Tipo",
    "professional_v3_multi": "Agente - Base/Categoría (Multi Precio)",
    "business_new_multi": "Negocio - Base/Categoría (Multi Precio)",
    "price_new_multi": "Negocio - Categoría/Tipo (Multi Precio)",
    "professional_v4": "Agente - Categoría/Tipo",
    "professional_v4_multi": "Agente - Categoría/Tipo (Multi Precio)",
    "professional_v1": "Profesional V1",
    "professional_v2": "Profesional V2",
    "bussiness": "Negocio",
    "display_mode": "Modo de visualización",
    "room_mode": "Modo habitación",
    "internal": "Interno",
    "tab": "Pestaña",
    "config_saved": "Configuración guardada",
    "room_changed_after_one_hotel_search": "Habitación cambiada tras una búsqueda de hotel",
    "get_serialiezed_config": "Obtener configuración serializada",
    "serialized_config_clipboard": "Configuración serializada copiada en el portapapeles",
    "center_me": "Centrarme",
    "focus": "Centrar",
    "pin_this_item": "Fijar este elemento",
    "room_status": "Estado de la habitación",
    "about_room": "Acerca de la habitación",
    "room_info": "Información de la habitación",
    "preffered": "Preferida",
    "excluded": "Excluido",
    "preferred_saved": "Configuración del hotel preferido guardada",
    "language": "Idioma",
    "positive_reviews": "Opiniones positivas",
    "negative_reviews": "Reseñas negativas",
    "price_breakdown": "Desglose de precios",
    "non_ref": "No reembolsable",
    "rooms_were_not_found": "No se encontraron habitaciones",
    "add_special_request": "Añadir petición especial",
    "please_add_special_request": "Por favor, añada una petición especial",
    "sorry_we_cant_find_hotel_here": "Lo sentimos, no podemos encontrar el hotel aquí",
    "we_are_checking_for_better_rates": "Estamos buscando mejores tarifas",
    "we_are_waiting_for_the_chosen_room": "Estamos esperando la habitación elegida",
    "original_room_description": "Descripción original de la habitación",
    "hotel_reservation_in_process": "Reserva de hotel en curso",
    "number_of_persons": "Número de personas",
    "search_room": "Buscar habitación",
    "google": "Google",
    "tripadvisor": "Tripadvisor",
    "monitor": "Monitor",
    "copy": "Copia",
    "proposal": "Propuesta",
    "find_nearly": "Encontrar cerca",
    "preferred_hotel": "Hotel preferido",
    "system_recommended": "Recomendado por el sistema",
    "travel_agent_recommended": "Recomendado por el agente de viajes",
    "client_recommended": "Recomendado por el cliente",
    "stars": "Estrellas",
    "search": "Búsqueda en progreso",
    "prices": "Precios",
    "reviews": "Comentarios",
    "photos": "Fotos",
    "positive": "Positivo",
    "neutral": "Neutral",
    "negative": "Negativo",
    "rated_by_reviews": "Valorado por {{rating}} comentarios",
    "reservation_is_refundable": "Esta reserva es reembolsable según las reglas de tarifa/tarifa.",
    "reservation_is_not_refundable": "Esta reserva no es reembolsable según las reglas de tarifa/tarifa.",
    "choose_up_to_5_cards": "Elige hasta 5 tarjetas",
    "multi_payment": "Multi pagos",
    "please_apply_every_price": "Por favor, aplica cada precio",
    "please_enter_valid_price": "Por favor, ingresa un precio válido",
    "view_1": "Vista 1",
    "view_2": "Vista 2",
    "display_style": "Estilo de visualización",
    "positive_reviews_tags": "Etiquetas de reseñas positivas",
    "negative_reviews_tags": "Etiquetas de reseñas negativas",
    "ai_notes": "Notas de AI",
    "hotel_type": "Tipo de hotel",
    "apartment": "Apartamento",
    "villa": "Villa",
    "view_on_website": "Página web del hotel"
  },
  "proposal": {
    "s": "Propuestas",
    "remove_proposal": "Eliminar propuesta",
    "max_images_selected": "Has seleccionado el número máximo de imágenes",
    "proposal_removed": "Propuesta eliminada",
    "display_order": "Orden de visualización",
    "proposal": "Propuesta",
    "no": "No hay propuestas",
    "download_pdf": "Descargar PDF",
    "send_email": "Enviar Email",
    "create": "Crear propuesta",
    "clear_all": "Borrar todo",
    "write_comments": "Escriba aquí sus comentarios...",
    "reviews": "Comentarios",
    "created": "Propuesta creada",
    "show_price": "Mostrar precio",
    "please_select_rooms": "Por favor, seleccione habitaciones",
    "update": "Actualizar",
    "update_all": "Actualizar todo",
    "fixed_value": "Valor fijo",
    "percentage": "Porcentaje",
    "edit_price": "Editar precio",
    "value": "Valor",
    "add_to": "Añadir a la propuesta",
    "details": "Detalles",
    "amenities": "Amenidades",
    "all_of_images": "Todas las imágenes",
    "dep": "Dep.",
    "dep_airport": "Dep. Aeropuerto",
    "arr": "Arr.",
    "arr_airport": "Arr. Aeropuerto",
    "dynamic": "Dinámico",
    "generated_by_user": "Generado por el usuario",
    "created_at": "Creado el",
    "flight_and_hotel": "Vuelo y hotel",
    "google_images": "Importante información: las imágenes de los hoteles de Google",
    "customize": "Personalizar",
    "simple_template": "Plantilla simple",
    "colorful_template": "Plantilla colorida",
    "contrast_template": "Plantilla de contraste",
    "room_price_option": "Opción de precio de habitación",
    "description": "Descripción",
    "edit": "Editar propuesta",
    "some_of_the_products_were_expired": "Algunos de los productos han expirado",
    "by_order_id": "Por orden #",
    "by_service_date": "Por fecha de servicio",
    "original": "Original",
    "overwrite_price": "Sobrescribir precio",
    "discount_hotel_limit": "Descuento del hotel limit {{minPrice}}",
    "save": "Guardar propuesta",
    "whatsapp_message": "Por favor, encuentre adjunto el documento de propuesta de viaje. {{url}}",
    "telegram_message": "Por favor, encuentre adjunto el documento de propuesta de viaje.",
    "item_view": "Vista de ítem",
    "trip_view": "Vista de viaje"
  },
  "map": {
    "list": "Lista",
    "map": "Mapa",
    "show": "Mostrar mapa"
  },
  "bed_filter": {
    "title": "Filtrar por habitación",
    "pin_only": "Solo fijados"
  },
  "assistant": {
    "tab_tooltip": "Asistente IA",
    "greeting": "Pregunta sobre hoteles o vuelos, por ejemplo: \"vuelos a París la próxima semana\" o \"hoteles de 5 estrellas con desayuno\".",
    "placeholder": "Pregunta sobre hoteles o vuelos…",
    "connecting": "Conectando…",
    "send": "Enviar",
    "connection_error": "No se pudo conectar con el asistente. Inténtalo de nuevo.",
    "send_error": "No se pudo enviar tu mensaje. Inténtalo de nuevo.",
    "loading": "Cargando…",
    "session": "Sesión",
    "copy_session_id": "Copiar ID de sesión",
    "copied": "Copiado",
    "model": "Modelo de IA",
    "session_viewer": "Visor de sesiones",
    "results_opened": "Los resultados están en la página",
    "search_failed": "No se pudo abrir la búsqueda en la página. Inténtalo de nuevo.",
    "widget_title": "Asistente IA",
    "widget_open": "Abrir el asistente IA",
    "widget_close": "Minimizar el asistente IA",
    "widget_new_reply": "Nueva respuesta del asistente IA",
    "voice": {
      "record": "Grabar un mensaje de voz",
      "stop": "Enviar mensaje de voz",
      "cancel": "Cancelar grabación",
      "recording": "Grabando…",
      "mic_denied": "El micrófono está bloqueado. Permítelo para este sitio en el navegador e inténtalo de nuevo.",
      "unsupported": "Los mensajes de voz no son compatibles con este navegador.",
      "not_understood": "No pude entender el mensaje. Inténtalo de nuevo.",
      "error": "No se pudo procesar el mensaje de voz. Inténtalo de nuevo.",
      "limit": "Demasiados mensajes de voz. Inténtalo de nuevo más tarde."
    },
    "feedback": {
      "open": "Valorar esta respuesta",
      "sent": "Tu opinión fue enviada. Haz clic para cambiarla",
      "title": "Tu opinión",
      "q_understood": "¿Entendió tu solicitud?",
      "q_correct": "¿Información correcta?",
      "q_helped": "¿Te ayudó a avanzar?",
      "yes": "Sí",
      "no": "No",
      "placeholder": "¿Algo más? (opcional)",
      "send": "Enviar",
      "sending": "Enviando…",
      "thanks": "¡Gracias por tu opinión!",
      "error": "No se pudo enviar tu opinión. Inténtalo de nuevo.",
      "close": "Cerrar",
    },
    "viewer": {
      "title": "Asistente IA · Visor de sesiones",
      "close": "Cerrar",
      "company": "Empresa",
      "department": "Departamento",
      "branch": "Sucursal",
      "user": "Usuario",
      "status": "Estado",
      "from": "Desde",
      "to": "Hasta",
      "search": "Buscar",
      "search_placeholder": "ID de sesión o palabras del chat",
      "all_companies": "Todas las empresas",
      "all_departments": "Todos los departamentos",
      "all_branches": "Todas las sucursales",
      "all_users": "Todos los usuarios",
      "all_statuses": "Todos los estados",
      "reset": "Restablecer",
      "refresh": "Actualizar",
      "col_started": "Inicio",
      "col_last": "Última actividad",
      "col_user": "Usuario",
      "col_company": "Empresa",
      "col_department": "Departamento",
      "col_branch": "Sucursal",
      "col_messages": "Mensajes",
      "col_status": "Estado",
      "col_first_message": "Primer mensaje",
      "empty": "Ninguna sesión coincide con estos filtros.",
      "error": "No se pudieron cargar las sesiones. Inténtalo de nuevo.",
      "forbidden": "Solo el personal de BePro puede abrir el visor de sesiones.",
      "rows_per_page": "Filas por página",
      "range": "{{from}}–{{to}} de {{total}}",
      "prev": "Página anterior",
      "next": "Página siguiente",
      "details": "Sesión",
      "locale": "Idioma",
      "search_id": "ID de búsqueda",
      "tokens": "Tokens",
      "tokens_short": "tokens",
      "feedback_filter": "Opiniones",
      "col_feedback": "Opiniones",
      "col_tokens": "Tokens enviados / recibidos",
      "tokens_in_out_hint": "Tokens enviados al modelo / recibidos de él",
      "feedback_open": "Ver las opiniones",
      "feedback_title": "Opiniones",
      "feedback_open_session": "Abrir la sesión",
      "feedback_empty": "No hay opiniones en esta sesión.",
      "feedback_like": "Le gustó",
      "feedback_dislike": "No le gustó",
      "feedback_comment": "Solo comentario",
      "feedback_comment_label": "Comentario",
      "feedback_no_text": "Sin comentario",
      "feedback_q_understood": "Entendió la solicitud",
      "feedback_q_correct": "Información correcta",
      "feedback_q_helped": "Ayudó a avanzar",
      "feedback_yes": "Sí",
      "feedback_no": "No",
      "feedback_unanswered": "—",
      "feedback_question": "Pregunta del usuario",
      "feedback_answer": "Respuesta del asistente",
      "feedback_copy": "Copiar para el desarrollador",
      "feedback_copy_header": "Opinión sobre el Asistente IA",
      "feedback_rating": "Valoración",
      "feedback_date": "Fecha",
      "conversation": "Conversación",
      "tool_calls": "Llamadas a herramientas",
      "show_tools": "Mostrar llamadas a herramientas",
      "blocked_by_guard": "Bloqueado por el filtro",
      "failed_calls": "Llamadas fallidas",
      "role_user": "Usuario",
      "role_assistant": "Asistente",
      "role_system": "Sistema",
      "input": "Entrada",
      "error_detail": "Error",
      "no_messages": "Esta sesión aún no tiene mensajes."
    }
  },
  "package": {
    "package": "Paquete",
    "s": "Paquetes",
    "type": "Tipo",
    "destination": "Destino",
    "room_type": "Tipo de habitación",
    "tours": "Tours",
    "depart": "Salida",
    "return": "Regreso",
    "price_per_person": "Precio por persona",
    "total_price": "Precio total",
    "deal_features": "Características de la oferta",
    "nights": "Número de noches",
    "nts": "Noches",
    "package_type": "Tipo de paquete",
    "occupancy": "Ocupación",
    "details": "Detalles del paquete",
    "category": "Categoría",
    "taxes": "Impuestos",
    "per_person": "Promedio/paquete",
    "board_type": "Tipo de régimen",
    "country": "País",
    "language": "Idioma",
    "including": "Incluye",
    "not_including": "No incluye",
    "more_info": "Más información",
    "terms_of_cancellation": "Condiciones de cancelación",
    "important_info": "¡Información importante!",
    "it_is_your_res": "Es su responsabilidad leer el sitio web ",
    "terms_of_use": "términos de uso ",
    "and_all_conditions": " y todas las condiciones y términos relativos a su pedido",
    "general_conditions": "Condiciones generales y cancelaciones",
    "alphabetically": "Alfabéticamente",
    "popular": "Destinos populares",
    "per_trip": "Por viaje",
    "provider": "Proveedor",
    "flight": "Detalles del vuelo",
    "select_num_pax": "Seleccionar número de pasajeros",
    "supplier_terms": "Condiciones del proveedor",
    "immediate_approval": "Aprobación inmediata",
    "please_select_flight": "Por favor seleccione un vuelo",
    "status_go_to_m_or_req_1": "Pedido nº {{number}} ha sido enviado al proveedor para su aprobación.",
    "status_go_to_m_or_req_2": "Una vez confirmada definitivamente la reserva, recibirá otro correo electrónico con los detalles confirmados del pedido.",
    "you_need_to_choose_room_first": "Debe elegir la habitación primero",
    "catalog_additional_payments": "Pagos adicionales del catálogo",
    "sorry_we_couldnt_locate_item": "Lo sentimos, no pudimos localizar el elemento.",
    "room_no": "Número de habitación",
    "complect": "Complecto",
    "room_type_accommodation_base": "Tipo de habitación + base de alojamiento",
    "add_room_to_reservation": "Añadir habitación a la reserva",
    "room_selection": "Selección de habitación"
  },
  "tour": {
    "tour": "Tour",
    "s": "Tours"
  },
  "close": "Cerrar",
  "more": "Más",
  "less": "Menos",
  "actions": "Acciones",
  "all": "Todos",
  "apply": "Aplicar",
  "apply_2": "Aplicar",
  "choose": "Elije",
  "from": "de",
  "to": "a",
  "type": "Tipo",
  "at": "en",
  "km": "km",
  "name": "Nombre",
  "price": "Precio",
  "original_price": "Precio original",
  "reset": "Restablecer",
  "continue": "Continuar",
  "total": "Total",
  "basis": "Base",
  "taxes": "Impuestos",
  "back": "Volver",
  "days_sm": "d",
  "hours_sm": "h",
  "minutes_sm": "m",
  "confirm": "Confirmar",
  "title": "Título",
  "male": "Hombre",
  "female": "Mujer",
  "child": "Niño",
  "success": "Éxito",
  "failed_order": "Pedido fallido. Por Favor Llame al servicio de asistencia",
  "error": "Error",
  "notes": "Notas",
  "note": "Nota",
  "show_less": "Mostrar menos",
  "show_more": "Mostrar más",
  "show_all": "Mostrar todo",
  "no_entries": "No hay entradas",
  "best": "Mejor",
  "day": "Día",
  "ok": "OK",
  "of": "de",
  "add": "Añadir",
  "save": "Guardar",
  "yes": "Sí",
  "delete": "Eliminar",
  "order_created_successfully": "Pedido creado correctamente",
  "session_expired_try_again": "Sesión expirada. Vuelva a intentarlo",
  "cancel": "Cancelar",
  "NOFSHON": "Paquete Turistico",
  "change_choice": "Cambiar elección",
  "click_here": "Haz clic aquí",
  "details": "Detalles",
  "clear": "Borrar",
  "clear_all": "Borrar todo",
  "pay_wait": "Por favor espere...",
  "pay_wait_text": "Su pedido está siendo procesado",
  "pay_processing": "Procesando pago...",
  "normal": "Normal",
  "credit": "Crédito",
  "only_english_input": "Por favor, introduzca su nombre y apellidos tal como aparecen en el pasaporte",
  "nights": "noches",
  "something_went_wrong": "Algo ha ido mal",
  "accessibility": "Accesibilidad",
  "payment_error": "El pago falló",
  "MultipleDestinations": "Varias ciudades",
  "RoundTrip": "Ida y vuelta",
  "OneWay": "Sólo ida",
  "eEconomyClass": "Turista",
  "eEconomyPlusClass": "Turista Plus",
  "eBusinessClass": "Business",
  "rules": "Reglas",
  "click_for_details": "Haga clic para ver los detalles",
  "TRAVELFUSION": "LOW",
  "ro": "Habitación sin desayuno",
  "bb": "Desayuno incluido",
  "fb": "Pensión completa",
  "ai": "Todo incluido",
  "show_cancellation_date": "Mostrar fecha de cancelación",
  "cancellation_date_delta": "Delta de días de fecha de cancelación",
  "add_to": "Añadir a la propuesta",
  "max_images_selected": "Se pueden seleccionar un máximo de 3 imágenes",
  "ai_hotel_info": "Info hotel IA",
  "claude": {
    "pets": "Mascotas",
    "cancellation": "Cancelación",
    "adults_only": "Solo adultos",
    "website": "Sitio web",
    "notes": "Notas",
    "pros": "Ventajas",
    "cons": "Desventajas",
    "pros_cons": "Ventajas y desventajas",
    "not_found": "No se encontró el hotel"
  },
  "login": {
    "login": "Iniciar sesión",
    "login_your": "Acceda a su cuenta",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "success": "Iniciar sesión correctamente",
    "off_success": "Se ha desconectado correctamente",
    "error": "Nombre de usuario o contraseña incorrectos",
    "off": "Cerrar sesión",
    "contact_us": "Contacte con nosotros",
    "get_back": "Contacte con nosotros",
    "select_number": "Seleccione el número de pasajeros",
    "full_name": "Nombre y Apellidos",
    "contact_us_success": "Su mensaje se ha enviado correctamente",
    "contact_us_error": "Se ha producido un error al enviar su mensaje",
    "as": "Conectado como",
    "usercode": "Código de usuario"
  },
  "validation": {
    "numbers": "Sólo se permiten números",
    "email": "Correo electrónico incorrecto",
    "required": "Campo obligatorio",
    "minLength": "El campo debe contener {1} caracteres o más",
    "maxLength": "El campo debe contener {1} caracteres o menos",
    "length": "El campo debe contener {1} caracteres",
    "english": "Sólo se permiten caracteres en inglés"
  },
  "mo": {
    "mo": "Mis pedidos",
    "segment_gross_edited": "Segmento bruto editado correctamente",
    "lock_pnr": "Bloquear PNR",
    "unlock_pnr": "Desbloquear PNR",
    "lock_pnr_success": "PNR bloqueado correctamente",
    "unlock_pnr_success": "PNR desbloqueado correctamente",
    "logs": "Logs",
    "open_log": "Abrir log",
    "table_settings": "Configuración de la tabla",
    "support_ticket": "Ticket de soporte",
    "support_ticket_success": "Ticket de soporte creado correctamente",
    "subject": "Asunto",
    "reply": "Responder",
    "ticket": "Ticket",
    "ticket_updated": "Ticket actualizado correctamente",
    "segment_id": "Id de segmento",
    "order_id": "Id de pedido",
    "order": "Pedido",
    "local": "Local",
    "supplier_pnr": "Proveedor PNR",
    "backoffice_id": "Id Backoffice",
    "passenger_name": "Nombre del pasajero",
    "creation_date": "Fecha de creación",
    "orders": "Pedidos",
    "segment": "Seg.",
    "segment_full": "Segmento",
    "docket": "Expediente",
    "pnr": "PNR",
    "start": "Inicio",
    "name": "Nombre",
    "dest": "Dest.",
    "items": "Partidas",
    "clx": "CLX",
    "status": "S",
    "voucher": "V",
    "quantity": "Q",
    "total": "Total",
    "pay": "P",
    "supplier": "S",
    "end": "C",
    "agent": "Agente",
    "branch": "Sucursal",
    "order_details": "Datos del pedido",
    "check_in": "Entrada",
    "check_out": "Salida",
    "nights": "Noches",
    "date_c": "Fecha C",
    "segment_details": "Detalles del segmento",
    "paxes": "P.",
    "legs": "T.",
    "class": "C.",
    "date_time": "Fecha y Hora",
    "arrival": "Llegada",
    "status_full": "Estado",
    "pnr_ref": "Ref. PNR",
    "supplier_full": "Proveedor",
    "emergency_phone": "Teléfono de emergencia",
    "support_email": "Correo electrónico de apoyo",
    "emergency_email": "Email de emergencia",
    "amount": "Importe",
    "gross": "Bruto",
    "coupon_code": "Código del cupón",
    "total_gross": "Total Bruto",
    "total_net": "Total Neto",
    "disc_coupon": "Dis. Cupón",
    "vat": "IVA",
    "total_due": "Total DUE",
    "client_id": "Id Cliente",
    "discount": "Descuento",
    "comission": "Comisión",
    "profit": "Beneficio",
    "remarks": "Observaciones",
    "remark": "Observación",
    "info": "Información",
    "remark_code": "Código",
    "order_seg_remark_id": "Id de observación",
    "desc": "Mensaje",
    "user": "Usuario",
    "dateC": "Fecha C",
    "depatment": "Departamento",
    "voucher_full": "Voucher",
    "print_voucher": "Imprimir Vale",
    "voucher_number": "Número del Voucher",
    "backoffice_voucher_identity_number": "Número de identificación del comprobante en backoffice",
    "status_the_same": "El estado es el mismo",
    "status_changed": "El estado ha cambiado a {{status}}",
    "current_status": "Estado actual",
    "product_type": "Tipo de producto",
    "back_to_orders": "Volver a Pedidos",
    "cancel_order": "Cancelar el pedido",
    "segments": "Segmentos",
    "booking_about_to_cancel": "Esta reserva está a punto de cancelarse.",
    "are_you_sure": "¿Está seguro?",
    "order_cancelled": "Pedido cancelado con éxito. El estado ha cambiado a {{status}}",
    "hello": "Hola",
    "user_code": "Código de usuario",
    "department": "Departamento",
    "loading": "Cargando...",
    "supp": "Proveedor",
    "pnr_to_docket": "PNR a Documento",
    "docket_success": "Documento guardado correctamente",
    "clipboard_success": "Datos copiados al portapapeles",
    "no_data_found": "No se han encontrado datos",
    "room_preferences": "Preferencias de habitación",
    "guest_notes": "Notas del huésped",
    "additional_requirements": "Requisitos adicionales",
    "please_double_bed": "Si es posible, confirme una habitación con una <b>cama doble</b>",
    "please_twin_beds": "Si es posible, confirme una habitación con <b>dos camas individuales</b>",
    "please_high_floor": "Si es posible, confirme una habitación en una <b>planta alta</b>",
    "please_low_floor": "Si es posible, confirme una habitación en una <b>planta baja</b>",
    "please_non_smoking": "Si es posible, confirme una habitación <b>para no fumadores</b>",
    "please_smoking": "Si es posible, confirme una habitación <b>para fumadores</b>",
    "please_adjoining_room": "Si es posible, confirme una habitación <b>contigua</b>",
    "please_connecting_rooms": "Si es posible, confirme <b>habitaciones comunicadas</b>",
    "please_quiet_room": "Si es posible, confirme una habitación <b>tranquila</b>",
    "please_bathtub": "Si es posible, confirme una habitación con <b>bañera</b>",
    "please_accessible_room": "Si es posible, confirme una habitación <b>accesible</b> o <b>adaptada para discapacitados</b> con <b>ducha a ras de suelo</b> (el cliente utiliza silla de ruedas)",
    "note_late_arrival": "Tenga en cuenta que el huésped llegará <b>tarde (después de las 19:00)</b>",
    "confirm_early_arrival": "Confirme la <b>llegada anticipada</b> aproximadamente a las: ______",
    "confirm_late_arrival": "Confirme la <b>llegada tardía</b> aproximadamente a las: ______",
    "confirm_late_checkout": "Confirme la <b>salida tardía</b> aproximadamente a las: ______",
    "note_no_voucher": "Tenga en cuenta: <b>el huésped llegará sin bono</b>",
    "note_honeymoon": "Tenga en cuenta: <b>los pasajeros están de luna de miel</b>",
    "confirm_baby_cot": "Si es posible, confirme una <b>cuna</b> para:<br>Nombre completo del bebé: {{fullName}} Fecha de nacimiento: {{dob}}",
    "add_confirm_baby_cot": "Añada un bebé a la habitación, si es posible, y confirme una cuna para él: nombre completo: {{fullName}} Fecha de nacimiento: {{dob}}",
    "if_child": "Esto es si el bebé está en el pedido",
    "if_no_child": "Si el bebé no está en el pedido",
    "please_enter_info_about_baby": "Introduzca la información del bebé",
    "change_request": "Solicitud especial",
    "change_request_success": "Solicitud especial enviada correctamente",
    "choose_requests_can_edit": "Seleccione la(s) solicitud(es) de la lista. Puede editar el texto de la solicitud aquí.",
    "order_information": "Pedido - Información",
    "order_public_price": "Pedido - Precio público",
    "order_send_order_email": "Pedido - Enviar pedido por correo electrónico",
    "order_agent": "Pedido - Agente",
    "order_operator": "Pedido - Operador",
    "print": "Imprimir",
    "send": "Enviar",
    "print_file_generated": "El archivo se ha creado con éxito.",
    "documents": "Documentos",
    "file_name": "Nombre del fichero",
    "file_type": "Tipo de archivo",
    "tran_id": "ID de transacción",
    "ptr_id": "ID del PTR",
    "reason": "Motivo",
    "token": "Fichero",
    "p": "P",
    "a": "A",
    "t": "T",
    "err_code": "El codigo del error",
    "payments": "Plazos",
    "order_report": "Informe de pedido",
    "order_report_sent_success": "Informe de pedido enviado correctamente",
    "send_to_me": "Enviarme correo electrónico {{email}}",
    "thin_report": "Informe delgado",
    "email_success": "Correo electrónico enviado correctamente",
    "voucher_type": "Tipo de vale",
    "regular_voucher": "Vale normal",
    "thin_voucher": "Vale reducido",
    "display_order": "Mostrar pedido",
    "issue_voucher": "Emitir Vale",
    "copied": "Texto guardado en el portapapeles",
    "link_copied": "Enlace copiado en el portapapeles",
    "send_support_message": "Enviar mensaje de soporte",
    "send_support_message_success": "Mensaje de soporte enviado correctamente",
    "add_comission": "Añadir comisión",
    "item": "Artículo",
    "search_again": "Buscar de nuevo",
    "download_success": "Descarga correcta",
    "units": "Unidades",
    "order_list_report": "Informe de lista de pedidos",
    "order_list_report_no_names": "Informe de lista de pedidos - Sin nombres",
    "order_list_report_by_param": "Informe de lista de pedidos por parámetro",
    "order_list_report_by_dest": "Informe de lista de pedidos por destino",
    "summary_report_by_department": "Informe resumido por departamento",
    "summary_report_by_branch": "Informe resumido por sucursal",
    "summary_report_by_supplier": "Informe resumido por proveedor",
    "orders_by_branch": "Pedidos por sucursal",
    "orders_by_currency": "Pedidos por moneda",
    "orders_by_supplier": "Pedidos por proveedor",
    "export_to_file": "Exportar a archivo",
    "export_to_file_no_names": "Exportar a archivo - Sin nombres",
    "export_to_file_refund": "Exportar a archivo - Reembolso",
    "refund_report": "Informe de reembolsos",
    "coupon_report": "Informe de cupones",
    "report_price": "Precio del informe",
    "public_price": "Precio público",
    "sys_total_agent": "Total del sistema - Agente",
    "sys_nett_operator": "Neto del sistema - Operador",
    "report_type": "Tipo de informe",
    "report": "Informe",
    "report_generated": "Informe generado con éxito",
    "currency": "Moneda",
    "tour_subject": "Asunto del tour",
    "add_remark": "Agregar comentario",
    "remark_added": "Comentario agregado con éxito",
    "ticket_number": "Número de ticket",
    "public": "Público",
    "private": "Privado",
    "body": "Cuerpo",
    "support_update": "Actualizar ticket",
    "support_update_success": "Ticket actualizado correctamente",
    "itinerary": "Itinerario",
    "include": "Incluido",
    "not_included": "No incluido",
    "information": "Información",
    "start_price": "Desde",
    "change_user": "Cambiar usuario",
    "change_user_success": "Usuario cambiado correctamente",
    "current_user": "Usuario actual",
    "data_saved": "Datos guardados correctamente",
    "agency": "Agencia",
    "currencies": "Monedas",
    "upload_logo": "Subir logo",
    "current_logo": "Logo actual",
    "new_logo": "Nuevo logo",
    "last_update": "Última actualización",
    "download": "Descargar",
    "documents_uploaded_successfully": "{{count}} documentos subidos correctamente",
    "no_files_selected": "No se han seleccionado archivos",
    "choose_files": "Seleccionar archivos",
    "delete_document": "Eliminar documento",
    "document_deleted": "Documento eliminado correctamente",
    "all_departments": "Todos los departamentos",
    "all_branches": "Todas las sucursales",
    "profile": "Profile",
    "set_different_user": "Establecer usuario diferente",
    "login_as": "Iniciar sesión como",
    "username": "Nombre de usuario",
    "reset": "Restablecer",
    "logged_as_user_successfully": "Iniciado sesión como usuario correctamente",
    "logged_as_user_reset_successfully": "Cerrado sesión como usuario correctamente",
    "add_payment": "Añadir pago"
  },
  "destination": {
    "s_our_top": "Nuestros destinos recomendados"
  },
  "search": {
    "new": "Nueva búsqueda",
    "remember_mode_enabled": "Modo de recuerdo activado",
    "open_details_in_new_tab": "Abrir detalles en una nueva pestaña",
    "your_latest_searches": "Tus últimas búsquedas",
    "radius": "Radio",
    "no_results": "No se han encontrado resultados",
    "destination": "Destino",
    "check_in": "Entrada",
    "check_out": "Salida",
    "max_occupancy": "Ocupación máxima",
    "rooms": "Habitaciones",
    "room": "Habitación",
    "star_rating": "Estrellas",
    "nationality": "Nacionalidad",
    "adults": "Adultos",
    "children": "Niños",
    "youths": "Jóvenes",
    "seniors": "Mayores",
    "infants": "Bebés",
    "adult": "Adulto",
    "child": "Niño",
    "youth": "Jóven",
    "senior": "60+",
    "infant": "Infante",
    "under": "menos de",
    "add_room": "Añadir habitación",
    "search": "Busqueda",
    "max_persons": "Max personas: {{count}}",
    "infants_warning": "El recuento de bebés debe ser inferior al de adultos",
    "history": "Historial de búsqueda",
    "age": "Edad del niño (2-16)",
    "suppliers": "Proveedores",
    "with_active_filters": "Mantener filtros",
    "display_exactly": "Mostrar exactamente",
    "search_type_id": "ID de tipo de búsqueda"
  },
  "sort": {
    "er": "Ordenar",
    "by": "Ordenar por",
    "price_increase": "Precio: de menor a mayor",
    "price_decrease": "Precio: de mayor a menor",
    "cxl_increase": "CXL: de menor a mayor",
    "cxl_decrease": "CXL: de mayor a menor",
    "airline_increase": "Aerolínea: (A - Z)",
    "airline_decrease": "Aerolínea: (Z - A)",
    "star_increase": "Estrella: de menor a mayor",
    "star_decrease": "Estrella: de mayor a menor",
    "hotel_increase": "Nombre del hotel: (A - Z)",
    "hotel_decrease": "Nombre del hotel: (Z - A)",
    "duration_increase": "Duración: de baja a alta",
    "duration_decrease": "Duración: de alta a baja",
    "departure_outbound_increase": "Despegue más temprano ({{dep}})",
    "departure_outbound_decrease": "Despegue más tardío ({{dep}})",
    "returning_outbound_increase": "Aterrizaje más temprano ({{arr}})",
    "returning_outbound_decrease": "Aterrizaje más tardío ({{arr}})",
    "departure_inbound_increase": "Despegue más temprano ({{arr}})",
    "departure_inbound_decrease": "Despegue más tardío ({{arr}})",
    "returning_inbound_increase": "Aterrizaje más temprano ({{dep}})",
    "returning_inbound_decrease": "Aterrizaje más tardío ({{dep}})",
    "recommended": "Recomendado",
    "distance": "Distancia",
    "distance_increase": "Distancia: (0 - 100)",
    "distance_decrease": "Distancia: (100 - 0)",
    "name": "Nombre",
    "star": "Estrella"
  },
  "group": {
    "gr": "Grupo",
    "special": "Especial",
    "group": "Solicitud especial",
    "request": "Solicitud especial",
    "request_type": "Tipo de solicitud",
    "hotel": "Hotel",
    "flight": "Vuelo",
    "destination": "Destino",
    "hotel_name": "Nombre del hotel",
    "room_type": "Tipo de habitación",
    "double": "Doble",
    "single": "Individual",
    "triple": "Triple",
    "quadro": "Cuádruple",
    "group_type": "Tipo de solicitud",
    "hotel_stars": "Estrellas del hotel",
    "stars_5": "5 estrellas",
    "stars_4": "4 estrellas",
    "stars_3": "3 estrellas",
    "stars_2": "2 estrellas",
    "star_1": "1 estrella",
    "number_of_rooms": "Número de habitaciones",
    "check_in": "Entrada",
    "check_out": "Salida",
    "contact_information": "Información de contacto",
    "agency_name": "Nombre de la agencia",
    "agent_fn": "Nombre del agente",
    "agent_ln": "Apellidos del agente",
    "agent_email": "Correo electrónico del agente",
    "agent_phone": "Teléfono del agente",
    "message": "Mensaje",
    "send_request": "Enviar solicitud",
    "request_sent": "Solicitud enviada correctamente",
    "from": "Desde",
    "to": "Para",
    "date": "Fecha",
    "flight_time": "Hora del vuelo",
    "airline": "Línea aérea",
    "number_of_passengers": "Número de pasajeros"
  },
  "filter": {
    "filter": "Filtrar",
    "free_text": "Texto libre",
    "s": "Filtros",
    "stops": "Paradas",
    "stop": "Parada",
    "stop_up": "Parada",
    "stops_sm": "paradas",
    "direct_flight": "Vuelos directos solamente",
    "direct_flights": "Vuelos directos solamente",
    "direct_flights_outbound": "Vuelos directos ida",
    "one_stop": "1 parada",
    "two_or_more_stops": "2+ paradas",
    "reset": "Restablecer filtros",
    "price_range": "Rango de precios",
    "times": "Horarios",
    "takeoff": "Despegue",
    "landing": "Aterrizaje",
    "duration": "Duración",
    "stop_duration": "Duración de la parada",
    "airlines": "Compañías aéreas",
    "airports": "Aeropuertos",
    "by_name": "Nombre del Hotel",
    "by_rooms": "Habitaciones",
    "by_stars": "Estrellas",
    "by_prices": "Por precios",
    "search_by_location": "Buscar por ubicación",
    "more": "Más filtros...",
    "free_cancellation": "Cancelación gratuita",
    "board": "Pensión",
    "clear": "Borrar filtros",
    "baggage": "Equipaje",
    "baggage_included": "Equipaje incluido",
    "baggage_not_included": "Equipaje no incluido",
    "meal": "Comida",
    "airline": "Línea aérea",
    "free_x": "Gratis",
    "is_less_than": "Es inferior a",
    "is_greater_than": "Mayor que",
    "free": "Gratis X",
    "preffered_hotels": "Hoteles preferidos",
    "breakfast": "Desayuno",
    "half_board": "Media pensión",
    "full_board": "Pensión completa",
    "all_inclusive": "Todo incluido",
    "max_price": "Max precio",
    "min_price": "Min precio",
    "max": "Max",
    "min": "Min"
  },
  "home": {
    "home": "Inicio",
    "session_expired": "Sesión caducada",
    "session_expired_desc": "Su sesión ha expirado. Intente buscar de nuevo",
    "go_back": "Volver al inicio",
    "search_out_of_date": "Los resultados de la búsqueda pueden no estar actualizados",
    "please_refresh": "Actualice los resultados de la búsqueda",
    "refresh_results": "Actualizar resultados",
    "new_search": "Nueva búsqueda",
    "confirmation_dialog": "Diálogo de confirmación",
    "password": "Contraseña",
    "wrong_password": "Contraseña incorrecta",
    "failed_to_pay": "No se ha podido crear el pedido, el pedido fue cancelado durante el proceso de reserva. Por favor, inténtelo de nuevo"
  },
  "passenger": {
    "as_client": "Como cliente",
    "as_agent": "Como agente",
    "details": "Datos del pasajero",
    "important_notes": "Notas importantes",
    "apartment_notes": "Por favor, tenga en cuenta: La recepción no está disponible en algunos apartamentos. La entrada es en línea, y los códigos de acceso se envían de antemano.",
    "passenger": "Pasajero",
    "s": "Pasajeros",
    "guest": "pasajero",
    "guests": "pasajeros",
    "gender": "Género",
    "male": "Hombre",
    "female": "Mujer",
    "ln": "Apellidos",
    "fn": "Nombre",
    "dob": "Fecha de nacimiento",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "confirm": "Por favor, confirme que acepta las condiciones",
    "read_more": "Más información",
    "attention": "Atención Su reserva ya está en política de penalización",
    "order_details": "Detalles del pedido",
    "cancellation_details": "Detalles de la cancelación",
    "cancellation_date": "Puede cancelar su pedido a más tardar el",
    "cancellation_outdate": "No se puede cancelar. Toda la comisión de cancelación",
    "booking_summary": "Resumen de la reserva",
    "room_count": "Numero de habitaciones",
    "confirm_order": "Confirmar pedido",
    "room": "Habitación",
    "optional_services": "Servicios opcionales (equipaje y comidas)",
    "methods_of_payment": "Formas de pago",
    "fast_secure": "Pago rápido y seguro con tarjeta de crédito",
    "transaction_type": "Tipo de transacción",
    "number_of_payments": "Número de plazos",
    "send_request_to_consultant": "Enviar solicitud al asesor de viajes",
    "green_button_tooltip": "¿Prefiere pagar a uno de nuestros representantes? Presione el botón verde para reservar su asiento y un representante lo llamará en breve.",
    "send_request": "Enviar solicitud",
    "rule_display": "Visualización de la regla",
    "rule_i": "Regla {{i}}. {{fareBase}} | {{airlineCode}} | {{departureCode}}-{{arrivalCode}}",
    "message": "Mensaje",
    "birthday": "Cumpleaños",
    "years": "Años",
    "confirm_order_text": "Confirmar pedido",
    "mr": "Sr.",
    "mrs": "Sra.",
    "miss": "Srta.",
    "ms": "Sra.",
    "dr": "Dr.",
    "prof": "Prof.",
    "title": "Título",
    "phone_country": "código del país",
    "add": "Añadir pasajero",
    "passport_valid_till": "Pasaporte válido hasta",
    "passport": "Pasaporte",
    "price_for_single_in_composition_for_double": "precio por persona hab. compuesta por dos personas",
    "order_id": "ID de pedido",
    "id_number": "Número de identificación",
    "cancel_order_success": "Enviado correctamente",
    "city": "Ciudad",
    "branch_title": "Título de la sucursal",
    "display_cancellation_policy": "Mostrar política de cancelación",
    "please_wait": "Por favor espere...",
    "your_payment_is_being_processed": "Su pago está siendo procesado",
    "fast_secure_multi_payment": "Pago rápido y seguro con hasta {{count}} tarjetas de crédito",
    "procces_with_revolut": "Procesar con Revolut",
    "pay": "Pagar",
    "every_hotel_has_room": "Cada hotel debe tener una habitación"
  },
  "access": {
    "accessibility_settings": "Ajustes de accesibilidad",
    "internet_accessibility": "La accesibilidad de Internet significa que las personas con discapacidad pueden utilizar Internet",
    "contrast": "Contraste",
    "dark": "Oscuro",
    "normal": "Normal",
    "bright": "Claro",
    "color": "Color",
    "high": "Alto",
    "black_white": "Blanco y Negro",
    "font_size": "Tamaño de fuente",
    "clear_selection": "Borrar selección"
  },
  "deal": {
    "tours": "Tours",
    "fly_drive": "Fly Drive",
    "nofshon": "Paquete turistico",
    "ski": "Esquí",
    "spa": "Spa",
    "sport": "Deporte",
    "cruise": "Crucero"
  },
  "cookie": {
    "cookie_policy": "Política de cookies",
    "title": "Valoramos tu privacidad.",
    "text": "Utilizamos cookies para mejorar tu experiencia de navegación, servir anuncios personalizados o contenido, y analizar nuestro tráfico. Al hacer clic en \"Aceptar todo\", aceptas nuestras cookies.",
    "accept": "Aceptar todo",
    "reject": "Rechazar todo"
  },
  "transfer": {
    "transfer": "Traslado",
    "s": "Traslados",
    "pickup": "Recogida",
    "dropoff": "Entrega",
    "time": "Hora",
    "max_people": "Máx. <span class=\"text-bold\">{{count}} personas</span></br> por vehículo",
    "max_suitcases": "Máx. <span class=\"text-bold\">{{count}} maletas</span></br> por vehículo",
    "est_time": "Tiempo estimado </br><span class=\"text-bold\">{{h}} {{min}}</span>",
    "select_transfer": "Seleccione su traslado desde",
    "distance": "Distancia",
    "arrival_details": "Detalles de llegada",
    "return_details": "Detalles de regreso",
    "vehicle": "Vehículo",
    "from": "Desde",
    "to": "Hasta",
    "choose_return": "Por favor, elija traslado de {{from}} a {{to}}",
    "choose_arrival": "Por favor, elija traslado de regreso de {{from}} a {{to}}",
    "continue_book": "Continuar con la reserva",
    "pay_via_cc": "Pagar con tarjeta de crédito",
    "details": "Detalles del traslado",
    "arrival_info": "Información de llegada",
    "return_info": "Información de regreso",
    "addresses": "Direcciones",
    "airports": "Aeropuertos",
    "diff_countries": "Los puntos de inicio y destino están en diferentes países. Por favor, preste atención.",
    "from_search": "¿Dónde recoger?",
    "to_search": "¿Dónde dejar?",
    "pick_up_date": "Fecha de recogida",
    "pick_up": "Pick up"
  }
};
